
































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch, Mixins } from "vue-property-decorator";
import PrefillMixin from "@/mixins/PrefillMixin";
import { KesadaranGCS } from "@/types";
import moment from "moment";
import ptiService from "@/services/TransferInternal";
import {
  PtiTransferRequest,
  PtiTransferResponseItem,
  SelectItem,
  TransferContent,
  LegacyTransferContent,
  ClinicalData
} from "@/types/pti";
import storeReferensiUnit from "@/store/modules/new/ReferensiUnit";
import { userModule } from "@/store/modules/user";
import { storeDokter } from "@/store/modules/dokter";
import { storePerawat } from "@/store/modules/perawat";
import { storePasien } from "@/store/modules/pasien";
import { appModule } from "@/store/modules/app";
import FrekuensiNadi from "@/components/pemeriksaan/assesmen/FrekuensiNadi.vue";
import FrekuensiNafas from "@/components/pemeriksaan/assesmen/FrekuensiNafas.vue";
import SaturasiOksigen from "@/components/pemeriksaan/assesmen/SaturasiOksigen.vue";
import SuhuBadan from "@/components/pemeriksaan/assesmen/SuhuBadan.vue";
import TekananDarah from "@/components/pemeriksaan/assesmen/TekananDarahNew.vue";
import { Tensi } from "@/types/asesmen";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";

const PREFILL_MAP: Record<string, string> = {
  sistole: "sistole",
  diastole: "diastole",
  nadi: "nadi",
  nafas: "nafas",
  suhu: "suhu",
  saturasiO2: "saturasiO2",
  gcs_e: "gcsEye",
  gcs_v: "gcsVerbal",
  gcs_m: "gcsMotor"
};

@Component({
  components: {
    TekananDarah,
    FrekuensiNadi,
    FrekuensiNafas,
    SuhuBadan,
    SaturasiOksigen,
    VCDateTimePicker
  }
})
export default class PengirimanTransferInternal extends Mixins(PrefillMixin) {
  prefillFormKey = "transfer_internal";

  prefillResolvePath(path: string) {
    const prop = PREFILL_MAP[path];
    if (!prop) {
      return { get: () => "__skip__", set: () => undefined };
    }
    return {
      get: () => (this as any)[prop],
      set: (v: any) => {
        const num = Number(v);
        (this as any)[prop] = v === "" || v === null || isNaN(num) ? v : num;
      }
    };
  }

  @Prop() readonly value: KesadaranGCS;

  reciveContent: {
    klinis: ClinicalData;
    note: string;
  } | null = null;

  @Prop() readonly showDescription = false;
  @Prop({
    default: ["sistole", "diastole", "nadi", "nafas", "suhu", "saturasiO2"]
  })
  params;
  @Prop() readonly register!: number;
  @Prop({ default: "" }) readonly pasienRm!: string;
  @Prop({ default: null }) readonly fromUnit!: number;
  @Prop({ default: false }) readonly isReadonly!: boolean;
  @Prop({ default: null }) selectedId: number;

  isLoading = false;
  currentTransferId: number | null = null;
  currentPenerimaanId: number | null = null;
  userLoginId = userModule.user.id;
  unitLoginId = userModule.user.unit_id;

  payload = {} as PtiTransferRequest;

  fromUnitId: string | null = null;
  toUnitId: string | null = null;
  searchUnitRanap = null;
  searchUnitTujuan = null;
  transferedAt: string | Date | null = null;
  receivedAt: string | Date | null = null;
  arrivedAt: string | Date | null = null;
  transportMethod: string | null = null;
  procedure: string[] = [];
  alat: string[] = [];
  penunjang: string[] = [];
  lampiran: string[] = [];
  diagText: string | null = null;
  alatLainnyaText: string | null = null;
  penunjangLainnyaText: string | null = null;
  lampiranLainnyaText: string | null = null;
  procedureLainnyaText: string | null = null;
  kualifikasi: string;

  dpjpUserId: number | null = null;
  fromUserId: number | null = null;
  pickupUserId: number | null = null;
  pickupAt: string | Date | null = null;
  isDijemput = false;

  removing = false;
  showDeleteModal = false;
  isForm = true;

  gcsEye: number | null = null;
  gcsVerbal: number | null = null;
  gcsMotor: number | null = null;
  kesadaran: string | null = null;
  djj: number | null = null;
  bbs: number | null = null;
  tb: number | null = null;
  bbl: number | null = null;
  apgarscore: number | null = null;
  apgarscore2: number | null = null;
  downscore: number | null = null;
  alasan: string | null = null;
  supervisiMpp = false;
  legacyContent: LegacyTransferContent = {};
  note: string | null = null;
  sistole: number | null = null;
  diastole: number | null = null;
  nadi: number | null = null;
  nafas: number | null = null;
  suhu: number | null = null;
  saturasiO2: number | null = null;
  rawData: PtiTransferResponseItem | null = null;

  formError: {
    eye: string | null;
    verbal: string | null;
    motor: string | null;
    tekananDarah: string | null;
    nadi: string | null;
    nafas: string | null;
    suhu: string | null;
    saturasiO2: string | null;
    transportMethod: string | null;
    alat: string | null;
    alatLainnyaText: string | null;
    penunjang: string | null;
    penunjangLainnyaText: string | null;
    lampiran: string | null;
    lampiranLainnyaText: string | null;
    transferedAt: string | null;
    toUnitId: string | null;
    dpjpUserId: string | null;
    diagText: string | null;
    kualifikasi: string | null;
    pickupUserId: string | null;
    pickupAt: string | null;
    alasan: string | null;
  } = {
    eye: null,
    verbal: null,
    motor: null,
    tekananDarah: null,
    nadi: null,
    nafas: null,
    suhu: null,
    saturasiO2: null,
    transportMethod: null,
    alat: null,
    alatLainnyaText: null,
    penunjang: null,
    penunjangLainnyaText: null,
    lampiran: null,
    lampiranLainnyaText: null,
    transferedAt: null,
    toUnitId: null,
    dpjpUserId: null,
    diagText: null,
    kualifikasi: null,
    pickupUserId: null,
    pickupAt: null,
    alasan: null
  };

  listKualifikasi = [
    { text: "dr. Spesialis", value: "1" },
    { text: "Dokter", value: "2" },
    { text: "Perawat/ Bidan PRA PK/ PRA BK", value: "3" },
    { text: "Perawat/ Bidan PK 1/ BK 1", value: "4" },
    { text: "Perawat/ Bidan PK 2/ BK 2", value: "5" },
    { text: "Perawat/ Bidan PK 3/ BK 3", value: "6" },
    { text: "Perawat/ Bidan PK 4/ BK 4", value: "7" },
    { text: "Penata Anestesi", value: "8" }
  ];

  listTransport = [
    { text: "Jalan Sendiri", value: "1" },
    { text: "Kursi Roda", value: "2" },
    { text: "Stretcher", value: "3" },
    { text: "Bed Pasien", value: "4" }
  ];

  listTindakan = [
    { text: "Operasi", value: "1" },
    { text: "Reposisi", value: "2" },
    { text: "Debrimen", value: "3" },
    { text: "Heacting", value: "4" },
    { text: "Punctie", value: "5" },
    { text: "Chest tube", value: "6" },
    { text: "GA", value: "7" },
    { text: "RA", value: "8" },
    { text: "lokal Anestesi", value: "9" },
    { text: "Defibrilasi", value: "10" },
    { text: "Kardioversi", value: "11" },
    { text: "Pacu Jantung", value: "12" },
    { text: "Trombolisis", value: "13" },
    { text: "RJP", value: "14" },
    { text: "Manual", value: "15" },
    { text: "Kuretase", value: "16" },
    { text: "Vakum", value: "17" },
    { text: "Partus", value: "18" },
    { text: "Intubasi", value: "19" },
    { text: "VTP", value: "20" },
    { text: "Resusitasi Neonatal", value: "21" },
    { text: "Syok Manajemen", value: "22" },
    { text: "Observasi Ketat", value: "23" },
    { text: "Lainnya", value: "99" }
  ];

  listAlatPendukung = [
    { text: "Ventilator", value: "1" },
    { text: "Pasien Monitor", value: "2" },
    { text: "Syiring Pump", value: "3" },
    { text: "Infus Pump", value: "4" },
    { text: "Oksigen", value: "5" },
    { text: "Lainnya", value: "99" }
  ];

  listDataPemeriksaanDilampirkan = [
    { text: "Laboratorium", value: "1" },
    { text: "Radiologi", value: "2" },
    { text: "EKG/EEG", value: "3" },
    { text: "Lainnya", value: "99" }
  ];

  listDataAdmDilampirkan = [
    { text: "Kelengkapan Jaminan", value: "1" },
    { text: "Persetujuan Tindakan", value: "2" },
    { text: "Laporan Persalinan", value: "3" },
    { text: "Laporan Operasi", value: "4" },
    { text: "Laporan Anestesi", value: "5" },
    { text: "Obat Yang Dibawakan", value: "6" },
    { text: "Lainnya", value: "99" }
  ];

  gcsEyeOptions = [
    { id: 1, name: "Tidak membuka mata" },
    { id: 2, name: "Dengan rangsangan nyeri" },
    { id: 3, name: "Dengan perintah suara" },
    { id: 4, name: "Spontan" },
    { id: 0, name: "NT" }
  ];
  gcsVerbalOptions = [
    { id: 1, name: "Tidak bersuara" },
    { id: 2, name: "Mengerang" },
    { id: 3, name: "Kata" },
    { id: 4, name: "Orientasi abnormal" },
    { id: 5, name: "Kalimat lengkap dan orientasi baik" },
    { id: 0, name: "NT" }
  ];
  gcsMotorOptions = [
    { id: 1, name: "Tidak bergerak" },
    { id: 2, name: "Response ekstensi abnormal" },
    { id: 3, name: "Response fleksi abnormal" },
    { id: 4, name: "Menjauhi nyeri" },
    { id: 5, name: "Melokalisir nyeri" },
    { id: 6, name: "Sesuai perintah" },
    { id: 0, name: "NT" }
  ];
  kesadaranLevelOpts = [
    { maxVal: 15, id: "compos mentis", text: "Compos Mentis" },
    { maxVal: 13, id: "apatis", text: "Apatis" },
    { maxVal: 11, id: "delirium", text: "Delirium" },
    { maxVal: 9, id: "somnolen", text: "Somnolen" },
    { maxVal: 6, id: "sopor", text: "Sopor" },
    { maxVal: 4, id: "semi-coma", text: "Semi Coma" },
    { maxVal: 3, id: "coma", text: "Coma" }
  ];

  timePickerProps = {
    format: "24hr",
    scrollable: true,
    max: moment().format("HH:mm:ss")
  };
  datePickerPropsTransfer = {
    locale: "id",
    max: moment().format("YYYY-MM-DD")
  };
  dateTimeFieldProps = { outlined: true, dense: true, "hide-details": "auto" };

  pickupAtInput() {
    if (this.pickupAt && moment(this.pickupAt).isAfter(moment())) {
      this.$nextTick(() => {
        this.pickupAt = null;

        appModule.sendErrorAlert(
          "Tanggal dan jam dijemput tidak boleh melebihi <br/>" +
            moment().format("DD-MM-YYYY HH:mm")
        );
      });
    }
  }

  datetimeInput() {
    const dtime = new Date();
    if (this.transferedAt > dtime) {
      this.$nextTick(() => {
        this.transferedAt = null;

        appModule.sendErrorAlert(
          "Tanggal dan jam tidak boleh melebihi <br/>" +
            moment().format("DD-MM-YYYY HH:mm")
        );
      });
    }
  }

  get listPenjemputOpts() {
    if (!this.fromUserId) {
      return [...this.listDokter, ...this.listPerawat];
    }
    return [...this.listDokter, ...this.listPerawat].filter(
      item => item.id !== this.fromUserId
    );
  }

  get listUnitTujuan() {
    if (!this.fromUnitId) {
      return this.listUnitRanap;
    }
    return this.listUnitRanap.filter(unit => unit.id !== this.fromUnitId);
  }

  get namaUnitAsal() {
    return this.listUnitRanap.find(unit => unit.id === this.fromUnitId)?.nama;
  }

  get namaUnitTujuan() {
    return (
      this.listUnitRanap.find(unit => unit.id === this.toUnitId)?.nama ??
      this.toUnitId
    );
  }

  get showPetugasPenjemput() {
    return this.isDijemput || !!this.pickupUserId;
  }

  get isSudahSampai() {
    return !!this.arrivedAt;
  }

  get arrivedInfoText() {
    return (
      "Sudah sampai di bangsal " +
      this.namaUnitTujuan +
      " " +
      this.formatDate(this.arrivedAt)
    );
  }

  get isReadonlyPenjemput() {
    if (this.isReadonly) return true;

    return !this.isDijemput;
  }

  handleLampiran() {
    if (this.lampiran.includes("99")) {
      const selectRef = this.$refs.lampiranSelect as HTMLElement;
      if (selectRef && typeof selectRef.blur === "function") {
        selectRef.blur();
      }
      this.$nextTick(() => {
        const inputRef = this.$refs.lampiranLainnyaInput as HTMLElement;
        if (inputRef && typeof inputRef.focus === "function") {
          inputRef.focus();
        }
      });
    } else {
      this.lampiranLainnyaText = "";
    }
  }

  reloadPage() {
    window.location.reload();
  }

  handlePenunjang(): void {
    if (this.penunjang.includes("99")) {
      const selectRef = this.$refs.penunjangSelect as HTMLElement;
      if (selectRef && typeof selectRef.blur === "function") {
        selectRef.blur();
      }
      this.$nextTick(() => {
        const inputRef = this.$refs.penunjangLainnyaInput as HTMLElement;
        if (inputRef && typeof inputRef.focus === "function") {
          inputRef.focus();
        }
      });
    } else {
      this.penunjangLainnyaText = "";
    }
  }

  handleAlat(): void {
    if (this.alat.includes("99")) {
      const selectRef = this.$refs.alatSelect as HTMLElement;
      if (selectRef && typeof selectRef.blur === "function") {
        selectRef.blur();
      }
      this.$nextTick(() => {
        const inputRef = this.$refs.alatLainnyaInput as HTMLElement;
        if (inputRef && typeof inputRef.focus === "function") {
          inputRef.focus();
        }
      });
    } else {
      this.alatLainnyaText = "";
    }
  }

  handleProcedure(): void {
    if (this.procedure.includes("99")) {
      const selectRef = this.$refs.procedureSelect as HTMLElement;
      if (selectRef && typeof selectRef.blur === "function") {
        selectRef.blur();
      }
      this.$nextTick(() => {
        const inputRef = this.$refs.procedureLainnyaInput as HTMLElement;
        if (inputRef && typeof inputRef.focus === "function") {
          inputRef.focus();
        }
      });
    } else {
      this.procedureLainnyaText = "";
    }
  }

  get listUnitRanap() {
    return storeReferensiUnit.unit;
  }

  get listDokter() {
    return storeDokter.list;
  }

  get listPerawat() {
    return storePerawat.listPerawat;
  }

  get storeUser() {
    return userModule.user;
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get rm() {
    return storePasien.identitasPasien?.rm;
  }

  get registerId() {
    return this.register;
  }

  set gcs(val: KesadaranGCS) {
    this.gcsEye = typeof val?.e == "number" ? Number(val.e) : null;
    this.gcsVerbal = typeof val?.v == "number" ? Number(val.v) : null;
    this.gcsMotor = typeof val?.m == "number" ? Number(val.m) : null;
  }

  get gcs(): KesadaranGCS {
    return {
      e: this.gcsEye,
      v: this.gcsVerbal,
      m: this.gcsMotor
    };
  }

  get gcsEyeOpts() {
    return this.gcsEyeOptions.sort((a, b) => b.id - a.id);
  }

  get gcsVerbalOpts() {
    return this.gcsVerbalOptions.sort((a, b) => b.id - a.id);
  }

  get gcsMotorOpts() {
    return this.gcsMotorOptions.sort((a, b) => b.id - a.id);
  }

  get kesadaranLevel() {
    const gcs = this.gcsEye + this.gcsVerbal + this.gcsMotor;

    const val = this.kesadaranLevelOpts
      .sort((a, b) => a.maxVal - b.maxVal)
      .find(item => gcs <= item.maxVal);

    return val && this.gcsEye && this.gcsVerbal && this.gcsMotor ? val : null;
  }

  formatDate(date) {
    return date ? moment(date).format("DD-MM-YYYY HH:mm") : null;
  }

  @Watch("kesadaranLevel")
  changeKesadaranLevel(val) {
    if (this.isLoading || this.isReadonly) return;
    this.$emit("changeKesadaran", val);
  }

  @Watch("gcs", { deep: true })
  changeGCS(val) {
    if (this.isLoading || this.isReadonly) return;
    this.$emit("changeGCS", val);
  }

  @Watch("value", { deep: true })
  changeValue(val) {
    this.gcs = JSON.parse(JSON.stringify(val));
  }

  @Watch("toUnitId", { deep: true })
  changeToUnitId(val, oldVal) {
    if (!this.currentTransferId && val !== oldVal) {
      this.pickupUserId = null;
    }
  }

  @Watch("isDijemput")
  changeIsDijemput(val: boolean) {
    if (!val) {
      this.pickupUserId = null;
      this.pickupAt = null;
      this.formError.pickupUserId = null;
      this.formError.pickupAt = null;
    }
  }

  set tensi(val: Tensi) {
    this.sistole = val.sistole;
    this.diastole = val.diastole;
  }
  get tensi(): Tensi {
    return {
      sistole: this.sistole,
      diastole: this.diastole
    };
  }

  @Watch("storeUser", { immediate: true, deep: true })
  onUserChange(val) {
    if (val?.id) {
      this.fromUserId = val.id;
    }
  }

  @Watch("register", { immediate: true })
  onRegisterChanged(val: number) {
    if (val) {
      this.resetForm();
    }
  }

  mounted() {
    const userUnitId = userModule.user.unit_id;
    if (userUnitId) {
      this.fromUnitId = userUnitId;
    }
    this.transferedAt = null;
    this.receivedAt = null;
    this.arrivedAt = null;
    storeReferensiUnit.getUnit();
    if (this.register == null) {
      this.resetForm();
    }
    if (this.selectedId && this.register) {
      this.loadExistingTransfer(this.selectedId);
    }
  }

  @Watch("selectedId")
  async onChangeSelectedId(val: number) {
    if (val) {
      await this.loadExistingTransfer(val);
    } else {
      this.resetForm();
    }
  }

  async loadExistingTransfer(id?: number) {
    if (this.isLoading) return;
    if (!this.register) return;

    try {
      this.isLoading = true;
      const response = await ptiService.getByRegister(this.register);
      const list: PtiTransferResponseItem[] = response?.data || [];

      const selected = id ? list.find(t => t.id === id) : list[0];

      if (selected) {
        this.currentTransferId = selected.id;
        setTimeout(() => {
          this.mapServiceDataToForm(selected);
          this.isLoading = false;
        }, 200);
      }
    } catch (e) {
      console.error(e);
      this.isLoading = false;
    } finally {
      this.isLoading = false;
    }
  }

  ttvLoading = false;

  private ttvSnapshot(): string {
    return Object.keys(PREFILL_MAP)
      .map(path => String((this as any)[PREFILL_MAP[path]] ?? ""))
      .join("|");
  }

  async generateTtv() {
    if (this.isReadonly || !this.register || this.ttvLoading) return;
    if (!this.pasienRm) {
      appModule.sendErrorNotice("No. RM pasien tidak tersedia.");
      return;
    }
    this.ttvLoading = true;
    try {
      const before = this.ttvSnapshot();
      await this.loadPrefill({
        pasien_rm: String(this.pasienRm),
        register_id: this.register
      });
      if (this.ttvSnapshot() !== before) {
        appModule.NoticeDelay("TTV terakhir berhasil disalin ke form.");
      } else if (
        this.prefillPayload &&
        Object.keys(this.prefillPayload.fields || {}).length > 0
      ) {
        appModule.NoticeDelay(
          "Semua kolom TTV/GCS sudah terisi — nilai yang ada tidak ditimpa."
        );
      } else {
        appModule.sendErrorNotice(
          "Belum ada data TTV pada kunjungan ini. Isi Monitor TTV terlebih dahulu."
        );
      }
    } finally {
      this.ttvLoading = false;
    }
  }

  setTensi(val: Tensi) {
    this.tensi = {
      sistole: !val.sistole && val.sistole != 0 ? null : Number(val.sistole),
      diastole: !val.diastole && val.diastole != 0 ? null : Number(val.diastole)
    };
  }

  setFrekNadi(val: number) {
    this.nadi = val == null ? null : Number(val);
  }

  setFrekNafas(val: number) {
    this.nafas = val == null ? null : Number(val);
  }

  setSuhu(val: number) {
    this.suhu = val == null ? null : Number(val);
  }

  @Watch("suhu")
  onSuhuChange(val: any) {
    if (!val) return;
    const str = val.toString().replace(/[^\d]/g, "");
    if (str.length === 3) {
      this.suhu = parseFloat(str.slice(0, 2) + "." + str.slice(2));
    }
    if (str.length > 3) {
      this.suhu = parseFloat(str.slice(0, 2) + "." + str.slice(2, 3));
    }
  }

  setSaturasiO2(val: number) {
    this.saturasiO2 = val == null ? null : Number(val);
  }

  get canEdit() {
    if (!this.selectedId) return false;

    if (this.receivedAt) return true;

    if (this.fromUserId != this.userLoginId) return true;

    return false;
  }

  get canDelete() {
    return (
      this.selectedId && this.fromUserId == this.userLoginId && !this.receivedAt
    );
  }

  get alasanReadonly(): string {
    if (this.receivedAt) {
      return (
        "Pasien sudah diterima unit tujuan, form penyerahan terkunci untuk " +
        "semua petugas. Perubahan hanya bisa dilakukan sebelum penerimaan."
      );
    }

    if (Number(this.fromUserId) !== Number(this.userLoginId)) {
      return (
        "Hanya petugas pengantar yang membuat transfer ini yang dapat " +
        "mengubah atau menghapusnya. Anda hanya bisa melihat."
      );
    }

    return (
      "Rekam medis kunjungan ini sudah terkunci (lewat batas waktu edit). " +
      "Ajukan akses revisi bila perlu mengubah."
    );
  }

  resetForm() {
    this.toUnitId = null;
    this.transferedAt = null;
    this.receivedAt = null;
    this.arrivedAt = null;
    this.$refs.transferedAt;
    this.diagText = null;
    this.dpjpUserId = null;
    this.kualifikasi = null;
    this.pickupUserId = null;
    this.pickupAt = null;
    this.isDijemput = false;
    this.transportMethod = null;
    this.procedure = [];
    this.alat = [];
    this.penunjang = [];
    this.lampiran = [];
    this.alatLainnyaText = null;
    this.procedureLainnyaText = null;
    this.penunjangLainnyaText = null;
    this.lampiranLainnyaText = null;

    this.gcsEye = null;
    this.gcsVerbal = null;
    this.gcsMotor = null;
    this.kesadaran = null;
    this.sistole = null;
    this.diastole = null;
    this.nadi = null;
    this.nafas = null;
    this.suhu = null;
    this.saturasiO2 = null;
    this.djj = null;
    this.bbs = null;
    this.tb = null;
    this.bbl = null;
    this.apgarscore = null;
    this.apgarscore2 = null;
    this.downscore = null;
    this.alasan = null;
    this.supervisiMpp = false;
    this.legacyContent = {};
    this.note = null;

    this.currentTransferId = null;
    this.currentPenerimaanId = null;

    this.formError = {
      eye: null,
      verbal: null,
      motor: null,
      tekananDarah: null,
      nadi: null,
      nafas: null,
      suhu: null,
      saturasiO2: null,
      transportMethod: null,
      alat: null,
      alatLainnyaText: null,
      penunjang: null,
      penunjangLainnyaText: null,
      lampiran: null,
      lampiranLainnyaText: null,
      transferedAt: null,
      toUnitId: null,
      dpjpUserId: null,
      diagText: null,
      kualifikasi: null,
      pickupUserId: null,
      pickupAt: null,
      alasan: null
    };
  }

  batal() {
    this.resetForm();
    this.$emit("cancel");
  }

  validateForm(): boolean {
    this.formError = {
      eye: null,
      verbal: null,
      motor: null,
      tekananDarah: null,
      nadi: null,
      nafas: null,
      suhu: null,
      saturasiO2: null,
      transportMethod: null,
      alat: null,
      alatLainnyaText: null,
      penunjang: null,
      penunjangLainnyaText: null,
      lampiran: null,
      lampiranLainnyaText: null,
      transferedAt: null,
      toUnitId: null,
      dpjpUserId: null,
      diagText: null,
      kualifikasi: null,
      pickupUserId: null,
      pickupAt: null,
      alasan: null
    };

    const validations = [
      {
        field: "toUnitId",
        isValid: () => this.toUnitId,
        message: "Unit Tujuan wajib diisi"
      },
      {
        field: "transferedAt",
        isValid: () => this.transferedAt,
        message: "Tanggal & Jam Transfer harus diisi"
      },
      {
        field: "dpjpUserId",
        isValid: () => this.dpjpUserId,
        message: "Dokter Yang Merawat wajib diisi"
      },
      {
        field: "diagText",
        isValid: () => this.diagText?.trim(),
        message: "Diagnosa Medis wajib diisi"
      },
      {
        field: "kualifikasi",
        isValid: () => this.kualifikasi,
        message: "Kualifikasi Petugas Pengantar wajib diisi"
      },
      {
        field: "transportMethod",
        isValid: () => this.transportMethod,
        message: "Cara Transportasi wajib diisi"
      },
      {
        field: "alat",
        isValid: () => this.alat?.length > 0,
        message: "Alat Pendukung wajib diisi/dipilih minimal satu"
      },
      {
        field: "alatLainnyaText",
        isValid: () =>
          !this.alat?.includes("99") || this.alatLainnyaText?.trim(),
        message: "Deskripsi alat lainnya wajib diisi",
        condition: () => this.alat?.includes("99")
      },
      {
        field: "penunjang",
        isValid: () => this.penunjang?.length > 0,
        message: "Data Pemeriksaan wajib diisi/dipilih minimal satu"
      },
      {
        field: "penunjangLainnyaText",
        isValid: () =>
          !this.penunjang?.includes("99") || this.penunjangLainnyaText?.trim(),
        message: "Deskripsi pemeriksaan lainnya wajib diisi",
        condition: () => this.penunjang?.includes("99")
      },
      {
        field: "lampiran",
        isValid: () => this.lampiran?.length > 0,
        message: "Data Administrasi wajib diisi/dipilih minimal satu"
      },
      {
        field: "lampiranLainnyaText",
        isValid: () =>
          !this.lampiran?.includes("99") || this.lampiranLainnyaText?.trim(),
        message: "Deskripsi administrasi lainnya wajib diisi",
        condition: () => this.lampiran?.includes("99")
      },
      {
        field: "alasan",
        isValid: () => this.alasan?.trim(),
        message: "Alasan wajib diisi"
      },
      {
        field: "eye",
        isValid: () => this.gcsEye != null,
        message: "GCS Eye harus diisi"
      },
      {
        field: "verbal",
        isValid: () => this.gcsVerbal != null,
        message: "GCS Verbal harus diisi"
      },
      {
        field: "motor",
        isValid: () => this.gcsMotor != null,
        message: "GCS Motor harus diisi"
      },
      {
        field: "nadi",
        isValid: () => this.nadi != null,
        message: "Frekuensi nadi harus diisi"
      },
      {
        field: "nafas",
        isValid: () => this.nafas != null,
        message: "Frekuensi nafas harus diisi"
      },
      {
        field: "suhu",
        isValid: () => this.suhu != null,
        message: "Suhu harus diisi"
      },
      {
        field: "saturasiO2",
        isValid: () => this.saturasiO2 != null,
        message: "Saturasi harus diisi"
      },
      {
        field: "pickupUserId",
        isValid: () => !!this.pickupUserId,
        message: "Petugas penjemput harus diisi",
        condition: () => this.isDijemput
      },
      {
        field: "pickupAt",
        isValid: () =>
          !this.transferedAt ||
          !moment(this.pickupAt).isBefore(moment(this.transferedAt), "minute"),
        message: "Tanggal dijemput tidak boleh sebelum tanggal transfer",
        condition: () => this.isDijemput && !!this.pickupAt
      }
    ];

    let hasError = false;
    validations.forEach(rule => {
      if (rule.condition && !rule.condition()) return;
      if (!rule.isValid()) {
        (this.formError as any)[rule.field] = rule.message;
        hasError = true;
      }
    });
    if (hasError) {
      appModule.sendErrorAlert("Mohon lengkapi semua data yang wajib diisi");
    }
    return !hasError;
  }

  formatList(
    selectedIds: string[],
    referenceList: { value: string; text: string }[],
    lainnyaText?: string
  ) {
    return selectedIds.map(id => {
      const refItem = referenceList.find(item => item.value === id);

      return {
        id: id,
        name: refItem?.text || "",
        text: id === "99" ? lainnyaText : ""
      };
    });
  }

  get pengirimanPayload(): PtiTransferRequest {
    return {
      id: this.currentTransferId || null,
      pasien_rm: this.rm ? String(Number(this.rm)) : this.pasienRm || null,
      register_id: this.registerId || null,
      from_unit_id: this.fromUnitId || "",
      to_unit_id: this.toUnitId || "",
      dpjp_user_id: this.dpjpUserId ? String(this.dpjpUserId) : "",
      from_user_id: this.fromUserId ? String(this.fromUserId) : null,
      pickup_user_id:
        this.isDijemput && this.pickupUserId ? String(this.pickupUserId) : null,
      pickup_at:
        this.isDijemput && this.pickupAt
          ? moment(this.pickupAt).format("YYYY-MM-DD HH:mm:ss")
          : null,
      is_dijemput: this.isDijemput,
      diag_text: this.diagText || null,
      transfered_at: this.transferedAt
        ? moment(this.transferedAt).format("YYYY-MM-DD HH:mm:ss")
        : null,
      received_at: this.receivedAt
        ? moment(this.receivedAt).format("YYYY-MM-DD HH:mm:ss")
        : null,
      arrived_at: this.arrivedAt
        ? moment(this.arrivedAt).format("YYYY-MM-DD HH:mm:ss")
        : null,
      transfer_content: {
        kualifikasi: this.kualifikasi ? String(this.kualifikasi) : null,
        transport_method: {
          id: this.transportMethod,
          name:
            this.listTransport.find(t => t.value === this.transportMethod)
              ?.text || ""
        },
        procedure: this.formatList(
          this.procedure,
          this.listTindakan,
          this.procedureLainnyaText
        ),

        alat: this.formatList(
          this.alat,
          this.listAlatPendukung,
          this.alatLainnyaText
        ),

        penunjang: this.formatList(
          this.penunjang,
          this.listDataPemeriksaanDilampirkan,
          this.penunjangLainnyaText
        ),

        lampiran: this.formatList(
          this.lampiran,
          this.listDataAdmDilampirkan,
          this.lampiranLainnyaText
        ),

        klinis: {
          kesadaran: this.kesadaranLevel?.id || null,
          gcs: {
            e: typeof this.gcsEye === "number" ? this.gcsEye : null,
            v: typeof this.gcsVerbal === "number" ? this.gcsVerbal : null,
            m: typeof this.gcsMotor === "number" ? this.gcsMotor : null
          },
          sistole: this.sistole || null,
          diastole: this.diastole || null,
          nadi: this.nadi || null,
          nafas: this.nafas || null,
          suhu: this.suhu || null,
          spo2: this.saturasiO2 || null,
          djj: this.djj || null,
          apgarscore: {
            "1": this.apgarscore || null,
            "5": this.apgarscore2 || null
          },
          downscore: this.downscore || null,
          bbl: this.bbl || null,
          bbs: this.bbs || null
        },
        alasan: this.alasan?.trim() || null,
        supervisi_mpp: this.supervisiMpp,
        ...this.legacyContent,
        note: this.note || null
      }
    };
  }

  async kirimData() {
    if (!this.validateForm()) {
      return;
    }
    this.isLoading = true;
    try {
      const payload = this.pengirimanPayload;

      let response: PtiTransferResponseItem | null = null;
      if (this.currentTransferId) {
        response = await ptiService.update(this.currentTransferId, payload);
        this.$emit("isForm", true);
      } else {
        response = await ptiService.create(payload);
        this.resetForm();
        this.selectedId = null;
        this.$emit("isForm", true);
      }
      this.$emit("onSubmit");
      if (response && response.id) {
        this.currentTransferId = response.id;
      }
      appModule.NoticeDelay("Data transfer internal berhasil disimpan");
      this.$emit("transfer-sent", response);
      this.$emit("isForm", true);
    } catch (error) {
      console.error("Error submitting form:", error);
      appModule.sendErrorNotice(
        "Gagal mengirim data. Periksa koneksi atau data input."
      );
    } finally {
      this.isLoading = false;
    }
  }

  mapServiceDataToForm(selected: PtiTransferResponseItem) {
    if (!selected) return;

    requestAnimationFrame(() => {
      this.fromUnitId = selected.from_unit_id || null;
      this.toUnitId = selected.to_unit_id || null;
      this.dpjpUserId = selected.dpjp_user_id
        ? Number(selected.dpjp_user_id)
        : null;
      this.fromUserId = selected.from_user_id
        ? Number(selected.from_user_id)
        : null;
      this.pickupUserId = selected.pickup_user_id
        ? Number(selected.pickup_user_id)
        : null;
      this.isDijemput =
        typeof selected.is_dijemput === "boolean"
          ? selected.is_dijemput
          : !!selected.received_unit_id &&
            String(selected.received_unit_id) ===
              String(selected.from_unit_id);
      this.diagText = selected.diag_text || null;
      this.transferedAt = selected.transfered_at
        ? moment(selected.transfered_at).toDate()
        : null;
      this.receivedAt = selected.received_at
        ? moment(selected.received_at).toDate()
        : null;
      this.arrivedAt = selected.arrived_at
        ? moment(selected.arrived_at).toDate()
        : null;
      this.pickupAt = selected.pickup_at
        ? moment(selected.pickup_at).toDate()
        : null;

      const tc: TransferContent = selected.transfer_content || {
        transport_method: null,
        procedure: [],
        alat: [],
        penunjang: [],
        lampiran: [],
        klinis: null,
        kualifikasi: null,
        note: ""
      };

      this.kualifikasi = tc.kualifikasi != null ? String(tc.kualifikasi) : null;

      this.transportMethod = tc.transport_method
        ? String(tc.transport_method.id)
        : null;

      this.procedure = (tc?.procedure || []).map((p: SelectItem) =>
        String(p.id)
      );
      const proc99 = (tc?.procedure || []).find(
        (p: SelectItem) => Number(p.id) === 99
      );
      this.procedureLainnyaText = proc99 ? proc99.text || null : null;

      this.alat = (tc?.alat || []).map((p: SelectItem) => String(p.id));
      const alat99 = (tc?.alat || []).find(
        (p: SelectItem) => Number(p.id) === 99
      );
      this.alatLainnyaText = alat99 ? alat99.text || null : null;

      this.penunjang = (tc?.penunjang || []).map((p: SelectItem) =>
        String(p.id)
      );
      const pen99 = (tc?.penunjang || []).find(
        (p: SelectItem) => Number(p.id) === 99
      );
      this.penunjangLainnyaText = pen99 ? pen99.text || null : null;

      this.lampiran = (tc?.lampiran || []).map((p: SelectItem) => String(p.id));
      const lamp99 = (tc?.lampiran || []).find(
        (p: SelectItem) => Number(p.id) === 99
      );
      this.lampiranLainnyaText = lamp99 ? lamp99.text || null : null;

      this.alasan = tc.alasan || null;
      this.supervisiMpp = tc.supervisi_mpp === true;
      const legacy: LegacyTransferContent = {};
      if (tc.temuan_signifikan) legacy.temuan_signifikan = tc.temuan_signifikan;
      if (tc.obat) legacy.obat = tc.obat;
      if (tc.perawatan_lain) legacy.perawatan_lain = tc.perawatan_lain;
      this.legacyContent = legacy;

      if (tc.klinis) {
        const klinis = tc.klinis;
        if (klinis.gcs) {
          this.gcsEye = klinis.gcs.e ?? null;
          this.gcsVerbal = klinis.gcs.v ?? null;
          this.gcsMotor = klinis.gcs.m ?? null;
        }
        this.kesadaran = klinis.kesadaran || null;
        this.sistole = klinis.sistole ?? null;
        this.diastole = klinis.diastole ?? null;
        this.nadi = klinis.nadi ?? null;
        this.nafas = klinis.nafas ?? null;
        this.suhu = klinis.suhu ?? null;
        this.saturasiO2 = klinis.spo2 ?? null;
        this.djj = klinis.djj ?? null;
        this.downscore = klinis.downscore ?? null;
        this.bbl = klinis.bbl ?? null;
        this.bbs = klinis.bbs ?? null;
        this.apgarscore = klinis.apgarscore["1"] ?? null;
        this.apgarscore2 = klinis.apgarscore["5"] ?? null;
        this.note = tc.note || null;
      }
    });
  }

  @Watch("kualifikasi")
  watchKualifikasi(val) {}

  async hapusData() {
    this.removing = true;

    try {
      const response = await ptiService.destroy(this.currentTransferId);

      appModule.NoticeDelay("Data transfer berhasil dihapus");
      this.showDeleteModal = false;

      this.$emit("onSubmit");
      this.$emit("transfer-sent", response);
      this.$emit("isForm", true);
    } catch (error) {
      console.error("Delete Error:", error);
      appModule.sendErrorNotice("Gagal menghapus data. Periksa koneksi.");
    } finally {
      this.removing = false;
    }
  }
}
